export default __webpack_public_path__ + "static/phantomjs-33f59294826610b2dd9b4e8edb16c707.png";